import { PofDocTypes } from "@modules/pof/components/pof-pow-type.enum";

export function stripSpecialCharacters(text: string): string {
	const splitExtension = text.lastIndexOf(".");
	const name = text.substring(0, splitExtension);
	const extension = text.substring(splitExtension);

	let textStripped = name.replace(/[^a-z0-9.() _-]/gi, "_");

	if (textStripped.replace(/[_ ]/g, "").length === 0) {
		let textStripped = "document";
		return textStripped.concat(extension);
	}
	return textStripped.concat(extension);
}

export function findContentTypeDocs(name: string, type: string): string {
	if (type === PofDocTypes.PDF || type === PofDocTypes.PNG || type === PofDocTypes.JPEG) {
		return type;
	}
	// This is needed because the file type jpg has to return always jpeg
	const getType = name.substring(name.lastIndexOf(".") + 1);
	return getType === "jpg" && PofDocTypes.JPEG;
}
